import { Factory, BadgeEuro, Zap, Heart, Shirt, ShieldCheck } from "@/components/Icon";
import FeatureCard from "@/components/FeatureCard";

const reasons = [
  { icon: ShieldCheck, title: "Professionele kwaliteit", desc: "Hoge kwaliteit prints en borduurwerk dankzij moderne apparatuur." },
  { icon: Factory, title: "Eigen productie", desc: "100% eigen productie in ons atelier in Den Haag. Niets wordt uitbesteed." },
  { icon: BadgeEuro, title: "Scherpe prijzen", desc: "Geen tussenpersonen. Eerlijke prijzen op maat, geen verborgen kosten." },
  { icon: Heart, title: "Persoonlijke service", desc: "Persoonlijk advies en begeleiding van ontwerp tot eindproduct." },
  { icon: Zap, title: "Snelle service", desc: "Flexibele levertijden, ook voor spoedopdrachten." },
  { icon: Shirt, title: "Ruim aanbod", desc: "T-shirts, polo's, hoodies, caps, bedrijfskleding en meer." },
];

const WhyUs = () => (
  <section className="py-20 md:py-28">
    <div className="container">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#0a2933]">
          Waarom Magic Print?
        </h2>
        <p className="text-muted-foreground">
          Dankzij onze ervaring en eigen apparatuur leveren wij hoge kwaliteit tegen scherpe prijzen.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {reasons.map((r) => (
          <FeatureCard
            key={r.title}
            icon={r.icon}
            title={r.title}
            description={r.desc}
          />
        ))}
      </div>
    </div>
  </section>
);

export default WhyUs;
